<template>
  <section class="bg-base-200 py-16">
    <div class="max-w-7xl mx-auto px-4">
      <h3 class="text-2xl font-semibold text-center mb-20">Our Trusted Partners</h3>
      
      <div class="flex flex-wrap justify-center items-center gap-12 md:gap-20">
        
        <div 
          v-for="(partner, index) in partners" 
          :key="index"
          class="flex items-center gap-3 opacity-60 grayscale hover:grayscale-0 hover:opacity-100 hover:text-primary transition-all duration-300 cursor-pointer"
        >
          <svg 
            class="w-10 h-10 fill-current" 
            viewBox="0 0 24 24" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path :d="partner.logoPath" />
          </svg>
          
          <span class="text-2xl font-bold tracking-tight">{{ partner.name }}</span>
        </div>

      </div>
    </div>
  </section>
</template>

<script setup>
// Using an array makes it very easy to swap these out with actual images or other icons later.
const partners = [
  {
    name: 'SpeedyDrop',
    // Lightning bolt icon
    logoPath: 'M13 10V3L4 14h7v7l9-11h-7z' 
  },
  {
    name: 'SecurePay',
    // Shield icon
    logoPath: 'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z' 
  },
  {
    name: 'FreshiFarms',
    // Leaf/Eco icon
    logoPath: 'M17 8C8 10 5.9 16.17 3.82 21.34l1.89.66l.95-2.3c.48.17.96.3 1.34.3C12 20 22 14 22 4c0 0-5 4-5 4z' 
  },
  {
    name: 'CityDine',
    // Storefront icon
    logoPath: 'M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z' 
  }
]
</script>